import {AnyAction} from "redux";
import {SHOW_NEXT_YEAR_END_QUESTION} from "../../actions/action";
import * as _ from 'lodash';
import {createSelector} from "reselect";
import {getQuestions, IQuestion, IYear} from "../../../data/data";
import {getYearData} from '../year';


//  define selectors

export const getYearEndQuestionID = state => state.question;

/**
 * get the data object for a question
 */
export const getYearEndQuestionData = createSelector(

    [getYearEndQuestionID, getYearData],

    (question_id: string, year_data: IYear) =>
    {
        const questions: IQuestion[] = getQuestions();

        return _.find(questions, ['id', year_data.year]) || _.first(questions)
    }
);

//  define the initial state

const initialState: string = null;


/**
 * reducer: set the current question ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function yearEndQuestion(state: string = initialState, action: AnyAction): string
{
    switch (action.type)
    {
        case SHOW_NEXT_YEAR_END_QUESTION:
        {
            const question_data: IQuestion[] = getQuestions();

            const current_index: number = _.findIndex(question_data, ['id', state]);

            const new_index: number = (current_index + 1 + question_data.length) % question_data.length || 0;

            console.group('reducer: question');
            console.log(current_index);
            console.log(new_index);
            console.log(question_data[new_index].id);
            console.groupEnd();

            return question_data[new_index].id;
        }

        // case SHOW_QUESTION:
        // {
        //     const {payload} = action;
        //     const {question_id} = payload;
        //
        //     return question_id;
        // }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/questions/yearEndQuestion.ts